export default [
    { lat: 48.190144, lng: 16.454619 },
    { lat: 48.181599, lng: 16.442828 },
    { lat: 48.157666, lng: 16.372082 },
    { lat: 48.139196, lng: 16.430524 },
    { lat: 48.143301, lng: 16.455644 },
    { lat: 48.156298, lng: 16.475125 },
    { lat: 48.163479, lng: 16.496657 },
]
